export default {
    code: 'zh',
    htmlLang: 'zh-Hans',
    ogLocale: 'zh_CN',
    selectLabel: '中文',
    meta: {
        home: {
            title: 'Irma Ariandi 牙科诊所 — Wear Your Smile | 新山牙科诊所',
            description: '位于新山的牙科诊所，专注传统牙套、隐形牙套（clear aligners）、FRC 与氧化锆牙冠牙桥。用心的牙科治疗，诚实的建议，透明的收费，人性化的关怀。',
        },
    },
    nav: {
        home: '首页',
        treatments: '治疗方案',
        teen: '青少年笑容',
        teenBadge: '家长指南',
        international: '国际患者',
        kolum: 'Coffee With Dr. Irma',
        doctors: '我们的医生',
        stories: '患者故事',
        contact: '联系我们',
        book: '预约',
        menu: '菜单',
        close: '关闭',
        language: '语言',
        treatmentsMenu: [
            { slug: 'conventional-braces', title: '传统牙套', desc: '成熟可靠的正畸治疗' },
            { slug: 'clear-aligners', title: '隐形牙套', desc: '更美观隐蔽的正畸选择' },
            { slug: 'frc', title: 'FRC 纤维加固', desc: '无需大手术的前牙修复' },
            { slug: 'zirconia-crowns-bridges', title: '氧化锆牙冠与牙桥', desc: '坚固美观的陶瓷修复' },
            { slug: 'aesthetic-veneers', title: '美学贴面与微笑改造', desc: '为您量身设计的笑容' },
        ],
        digitalLink: { path: '/digital-dentistry', title: '数字化牙科', desc: '现代治疗规划背后的科技' },
        internationalMenu: [
            { path: '/international/singapore', title: '新加坡', desc: '为新加坡患者而设' },
            { path: '/international/indonesia-batam', title: '印尼 / 巴淡岛', desc: '为巴淡岛及印尼患者而设' },
            { path: '/international', title: '概览', desc: '跨境就诊如何进行' },
        ],
        doctorsMenu: [
            { path: '/doctors/dr-irma-ariandi', title: 'Dr. Irma (DDS, UKM)', desc: '牙医 · 教育 · 写作' },
            { path: '/doctors/dr-ariandi', title: 'Dr. Ariandi (DDS, UKM)', desc: '牙医' },
        ],
    },
    cta: {
        whatsapp: 'WhatsApp 我们',
        whatsappLong: 'WhatsApp 诊所',
        book: '预约看诊',
        askIrma: '咨询 Dr. Irma',
        explore: '查看治疗方案',
        email: '发送电邮',
    },
    journeySteps: [
        { k: '01', t: '检查', d: '认真检查，正确诊断。' },
        { k: '02', t: '解释', d: '用简单的语言解释我们看到的状况。' },
        { k: '03', t: '选项', d: '把所有合理的选项摆在台面上。' },
        { k: '04', t: '收费', d: '治疗前讲清收费，而不是治疗后。' },
        { k: '05', t: '决定', d: '您做决定，我们提供建议。' },
        { k: '06', t: '治疗', d: '按您的节奏进行治疗。' },
        { k: '07', t: '复诊', d: '我们跟进、调整、长期观察。' },
    ],
    journeyNote: '每位患者都不同。实际的治疗流程，医生会在检查后亲自为您解释。',
    home: {
        hero: {
            badge: 'Klinik Pergigian Irma Ariandi · 新山',
            titleA: 'WEAR YOUR',
            titleB: 'SMILE.',
            sub: '用心的牙科治疗。诚实的建议。透明的收费。人性化的关怀。',
            sub2: '新山的正畸、修复与美学牙科护理 —— 细心规划，诚实解释。',
            chips: ['BRACES', 'CLEAR ALIGNERS', 'FRC', 'ZIRCONIA', 'VENEERS'],
            welcome: '欢迎来自柔佛、新加坡与印尼的患者。',
            imgCaption: '马来西亚 · 新山',
            imgAlt: '示意图片：健康的笑容',
        },
        marquee: ['Good dentistry', 'Pergigian yang baik', '用心的牙科', 'நல்ல பல் சிகிச்சை', 'Honest advice', 'Nasihat yang jujur', '诚实的建议', 'நேர்மையான ஆலோசனை', 'Transparent fees', 'Yuran yang telus', '透明的收费', 'வெளிப்படையான கட்டணம்', 'Human care', 'Penjagaan yang manusiawi', '人性化的关怀', 'மனிதநேயமான கவனிப்பு'],
        pathways: {
            eyebrow: '从哪里开始？',
            title: '您想为您的笑容改变什么？',
            sub: '告诉我们您的状况，我们会带您找到正确的资讯 —— 以及正确的对话。',
            items: [
                { id: 'straighter', label: '我想让牙齿更整齐。', to: '/treatments/conventional-braces' },
                { id: 'discreet', label: '我想要更隐蔽的方式让牙齿变整齐。', to: '/treatments/clear-aligners' },
                { id: 'brighter', label: '我想要更明亮、更美观的笑容。', to: '/treatments/aesthetic-veneers' },
                { id: 'shape', label: '我想改变牙齿的形状或比例。', to: '/treatments/aesthetic-veneers' },
                { id: 'broken', label: '我的门牙断裂或受损。', to: '/treatments/frc' },
                { id: 'restore', label: '我需要修复受损的牙齿。', to: '/treatments/zirconia-crowns-bridges' },
                { id: 'teen', label: '我想为我的孩子咨询牙套。', to: '/teen-smile' },
                { id: 'sg', label: '我从新加坡过来。', to: '/international/singapore' },
                { id: 'id', label: '我从印尼过来。', to: '/international/indonesia-batam' },
                { id: 'unsure', label: '我还不确定自己需要什么。', to: '/contact' },
            ],
        },
        pillars: {
            eyebrow: '五大治疗支柱',
            title: '专注的牙科，认真的态度',
            sub: '我们的临床工作集中在五个治疗领域 —— 这样才能做得好，也解释得诚实。',
            ctaCard: { title: '不确定哪种治疗适合？', text: '从一次对话开始 —— 我们帮您了解自己的选择。', cta: '安排咨询' },
        },
        why: {
            eyebrow: '患者为何选择我们',
            title: '患者为何选择 —— 并记住 —— 这家诊所',
            items: [
                { title: '诚实的建议', text: '如果不需要某项治疗，我们会直说；如果有更合理的选择，我们会提出。' },
                { title: '透明的治疗讨论', text: '选项与费用在治疗前解释清楚。没有意外。' },
                { title: '人性化的关怀', text: '患者记住的是愿意倾听的医生，以及值得信赖的医生。' },
                { title: '临床经验', text: '仔细的检查，认真的治疗。' },
                { title: '现代化牙科', text: '在临床条件合适的情况下，数字技术支持诊断与规划。' },
            ],
        },
        doctors: {
            eyebrow: '认识您的牙医',
            title: 'Dr. Irma Ariandi 与 Dr. Ariandi',
            sub: '两位牙医，同一种态度：认真检查、清楚解释、细心治疗。',
            irmaLine: '牙医 · 牙科教育者 · 作家 —— 曾是《Utusan Malaysia》的定期健康专栏作家。',
            ariandiLine: '牙医',
            cta: '认识我们',
        },
        teen: {
            eyebrow: '青少年笑容',
            title: '给家长看的青少年牙套指南',
            text: '为新山的家长准备：什么时候合适、第一次评估会做什么、如何从容地做决定。',
            points: [
                '第一次评估没有压力',
                '传统牙套 vs 隐形牙套',
                '治疗期间的上学、运动与口腔清洁',
            ],
            cta: '阅读家长指南',
        },
        intl: {
            eyebrow: '国际患者',
            title: '跨境就诊，安排妥当',
            sg: { title: '来自新加坡', text: '在新山进行隐形牙套治疗，复诊安排让您可以把复诊与到新山的行程结合起来。' },
            id: { title: '来自印尼 / 巴淡岛', text: '在新山进行隐形牙套与精选修复治疗，附有简单的出行指引与顺畅的沟通。' },
            aligner: '隐形牙套是我们国际患者的主要治疗 —— 在临床条件合适的情况下，复诊大约每 3 个月安排一次，让您可以把复诊安排进赴新山的行程里。',
            note: '需视乎个人临床需要、治疗方案、诊所/供应商条款及相关配送要求。',
            cta: '国际患者专区',
        },
        digital: {
            eyebrow: '我们的科技',
            title: 'WE EMBRACE DIGITAL DENTISTRY',
            p1: '现代牙科不只关乎我们做什么，也关乎我们如何规划。',
            p2: '在 Klinik Pergigian Irma Ariandi，数字技术支持特定领域的诊断、治疗规划与修复或美学流程。我们的口内扫描技术在临床条件合适的情况下，无需完全依赖传统取模，即可采集牙齿的数字影像。',
            note: '科技辅助临床判断 —— 而非取代判断。',
            cta: '了解数字化牙科',
        },
        veneers: {
            eyebrow: 'Aesthetic Veneers & Smile Makeover',
            title: '为您量身设计的笑容',
            text: '对于希望改善笑容颜色、形状、比例、对称性或整体外观的患者，在完成 proper 牙科评估后，美学贴面可能是其中一个治疗选择。每个笑容都不同。',
            artist: { title: 'THE ARTIST SMILE', text: '为偏爱更明亮、精致、上镜美学的患者而设。有的患者喜欢非常自然的色阶，有的则偏爱更明亮、更闪耀的美学 —— 目标在微笑规划中共同讨论。' },
            cta: '规划我的微笑咨询',
            ctaWa: '咨询贴面治疗',
        },
        kolum: {
            eyebrow: 'Coffee With Dr. Irma',
            title: '来自牙科诊椅旁的专栏',
            sub: 'Dr. Irma Ariandi 谈牙齿、诚实与生活 —— 延续她的健康专栏写作，如今以数字形式呈现。',
            empty: '这个语言的专栏文章正在准备中。先看看诊所在其他语言的文章吧。',
            cta: '阅读 Coffee With Dr. Irma',
        },
        remember: {
            eyebrow: '患者记得的事',
            title: '患者记得的事',
            sub: '真实患者的原话 —— 经同意分享，隐去姓名。按原样、以原本的语言发布。',
            themes: ['收费透明', '建议诚实', '亲切风趣的医生', '临床上的踏实', '人性化的关怀'],
            verifiedLabel: '已核实的患者',
        },
        journey: {
            eyebrow: '我们的理念',
            title: '先了解，后决定。',
        },
        nervous: {
            title: '害怕看牙医？',
            text: '告诉我们，我们理解。很多患者告诉我们他们曾经害怕 —— 我们会花时间解释，节奏由您决定。不说教，不施压。',
            cta: '在 WhatsApp 告诉我们',
        },
        location: {
            eyebrow: '跳访我们',
            title: '在新山找到我们',
            addressLabel: '地址',
            addressValue: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
            hoursLabel: '营业时间',
            hoursValue: '周日–周四：上午10:00 – 傍晚6:00（午餐休息 下午1:00 – 2:00）· 周六：上午9:00 – 中午12:30 · 周五与公共假期：休息 · 仅接受预约',
            mapNote: '诊所位于 Plaza Larkin 一楼（如上图建筑）。',
            whatsappLabel: 'WhatsApp',
            emailLabel: '电邮',
        },
        finalCta: {
            title: 'WEAR YOUR SMILE.',
            sub: '从一次对话开始。简单告诉我们您的顾虑 —— 我们会引导您走向合适的下一步。',
            primary: 'WhatsApp 诊所',
            secondary: '预约看诊',
        },
    },
    treatLabels: {
        who: '哪些人可能考虑这项治疗',
        problem: '针对的问题',
        assessment: '评估如何进行',
        options: '治疗方案',
        journey: '治疗旅程',
        know: '患者须知',
        followup: '复诊注意事项',
        faq: '常见问题',
        doctors: '您的医生',
        articles: '相关阅读',
        teenNoteLabel: '青少年患者 —— 家长须知',
        intlNoteLabel: '国际患者',
        ctaTitle: '还在考虑？',
        ctaText: '给诊所留言。我们会诚实地帮您了解这项治疗是否适合您。',
        digital: '数字化牙科支持',
    },
    teen: {
        metaTitle: '青少年笑容：家长牙套指南 | Irma Ariandi 牙科诊所',
        metaDesc: '给新山家长的诚实指南：牙套的合适年龄、第一次正畸评估、传统牙套与隐形牙套的取舍、治疗期间的校园生活。',
        title: '青少年笑容',
        subtitle: '家长指南',
        heroText: '要求戴牙套的不是您的孩子 —— 而是您在做功课，这正是正确的一步。这一页写给新山的家长，想平静而诚实地了解孩子的选择。',
        ctaTitle: '对孩子的牙齿有疑问？',
        ctaText: 'WhatsApp 我们的诊所。告诉我们孩子的年龄和您最担心的事 —— 我们会建议合适的下一步。',
    },
    international: {
        metaTitle: '国际患者 —— 新加坡与印尼 | Irma Ariandi 牙科诊所',
        metaDesc: '为来自新加坡、巴淡岛与印尼的患者提供新山牙科治疗。治疗流程、复诊结构与预约安排。',
        title: '国际患者',
        subtitle: '新加坡 · 印尼 / 巴淡岛',
        heroText: '我们接待从新加坡与印尼而来的患者 —— 尤其是隐形牙套与精选修复治疗。这一页在您联系我们之前，先解释清楚整个流程。',
    },
    kolum: {
        tagline: 'Dental Health · Smiles · Modern Dentistry',
        metaTitle: 'Coffee With Dr. Irma | Irma Ariandi 牙科诊所',
        metaDesc: 'Dr. Irma Ariandi（DDS, UKM）的牙科健康专栏 —— 新山牙医、牙科教育者、《Utusan Malaysia》前定期健康专栏作家。',
        title: 'Coffee With Dr. Irma',
        sub: 'Dr. Irma Ariandi（DDS, UKM）的专栏 —— 牙医、牙科教育者与作家，曾是《Utusan Malaysia》的定期健康专栏作家。',
        all: '全部',
        by: '作者',
        minRead: '分钟阅读',
        published: '发布于',
        updated: '更新于',
        empty: '这个语言的专栏正在准备中。先阅读诊所其他语言的文章吧。',
        langOf: '语言',
        back: '所有专栏',
        stillUnsure: {
            title: '仍然犹豫？',
            text: '咨询 Dr. Irma。简单告诉我们您的顾虑，诊所团队会引导您走向合适的下一步。',
            cta: 'WhatsApp 诊所',
            note: 'WhatsApp 沟通帮助诊所为您指路 —— 它不是诊断。',
        },
        relatedTreatment: '相关治疗',
        authorLine: '作者：Dr. Irma (DDS, UKM)，Klinik Pergigian Irma Ariandi。',
        sampleNote: '示例专栏 —— 内容将在正式上线前由诊所审核确认。',
    },
    doctors: {
        metaTitleIrma: 'Dr. Irma (DDS, UKM) — 牙医 · 教育者 · 作家 | 新山',
        metaDescIrma: 'Dr. Irma Ariandi（DDS, UKM）简介 —— 新山牙医、牙科教育者、《Utusan Malaysia》前定期健康专栏作家。',
        metaTitleAriandi: 'Dr. Ariandi (DDS, UKM) — 牙医 | Irma Ariandi 牙科诊所 · 新山',
        metaDescAriandi: 'Dr. Ariandi（DDS, UKM）简介 —— 新山 Irma Ariandi 牙科诊所的牙医。',
        profile: '医生简介',
        quals: '学历资格',
        interests: '治疗兴趣',
        philosophy: '治疗理念',
        articlesBy: '的专栏',
        pendingBio: '【医生简介待确认】',
        pendingInterests: '【治疗兴趣待确认】',
        pendingPhilosophy: '【治疗理念待确认】',
        cta: '与',
        irmaRoles: '牙医 · 牙科教育者 · 作家',
        irmaColumnist: 'Dr. Irma 曾是《Utusan Malaysia》的定期健康专栏作家。这个数字专栏延续她的健康写作传统 —— 如今在这里，服务新山、新加坡与印尼的患者。',
        ariandiRoles: '牙医',
    },
    stories: {
        metaTitle: '患者记得的事 | Irma Ariandi 牙科诊所',
        metaDesc: 'Irma Ariandi 牙科诊所的患者评价与故事 —— 仅在核实并获许可后发布。',
        title: '患者记得的事',
        sub: '真实患者的原话 —— 经同意分享，隐去姓名。按原样、以原本的语言发布。我们不修饰、不加工。',
        themesTitle: '患者常提到的主题',
        verifiedLabel: '已核实的患者',
        caseTitle: '病例故事',
        caseNote: '真实的病例故事 —— 患者的顾虑、讨论过的选项与治疗历程 —— 只会在取得患者书面同意并符合专业规范后发布。相关结构正在准备中。',
        caseSlot: '【真实病例故事，待填入】',
    },
    about: {
        metaTitle: '关于诊所 | Irma Ariandi 牙科诊所 · 新山',
        metaDesc: 'Irma Ariandi 牙科诊所位于新山 —— 用心的牙科治疗、诚实的建议、透明的收费、人性化的关怀。',
        title: '关于诊所',
        intro: 'Klinik Pergigian Irma Ariandi 是位于马来西亚柔佛新山的牙科诊所。我们的临床工作专注于五个治疗领域 —— 传统牙套、隐形牙套、FRC、氧化锆牙冠与牙桥、美学贴面与微笑改造 —— 背后是同一个承诺。',
        promisesTitle: '我们的承诺',
        promises: [
            { t: '用心的牙科治疗', d: '认真的工作，出于清楚的理由。' },
            { t: '诚实的建议', d: '我们说的，就是我们将会做 —— 或者不会做 —— 的事。' },
            { t: '透明的收费', d: '治疗前解释清楚，附有明确的明细。' },
            { t: '人性化的关怀', d: '您不是排队号码，而是我们认识的患者。' },
        ],
        philosophyTitle: '我们的治疗理念',
        photoSlot: '【诊所真实照片，待填入】',
    },
    contact: {
        metaTitle: '联系 / 预约 | Irma Ariandi 牙科诊所 · 新山',
        metaDesc: '通过 WhatsApp 011-3306 5735 或电邮联系新山 Irma Ariandi 牙科诊所。简单的预约咨询表单 —— 无需注册账号。',
        title: '联系我们',
        sub: '最快的方式是 WhatsApp。如果您更喜欢表单，我们也很乐意通过它为您提供帮助。',
        whatsappTitle: 'WhatsApp（最快）',
        emailTitle: '电邮 / 预约',
        addressTitle: '地址',
        addressValue: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
        hoursTitle: '营业时间',
        hoursValue: '周日–周四：上午10:00 – 傍晚6:00（午餐休息 下午1:00 – 2:00）· 周六：上午9:00 – 中午12:30 · 周五与公共假期：休息 · 仅接受预约',
        formTitle: '简短咨询表单',
        form: {
            name: '姓名',
            namePh: '您的姓名',
            method: '希望我们如何联系您？',
            methodOptions: ['WhatsApp', '电话', '电邮'],
            treatment: '感兴趣的治疗',
            treatmentOptions: ['传统牙套', '隐形牙套', 'FRC', '氧化锆牙冠与牙桥', '美学贴面', '还不确定', '其他'],
            phoneLabel: 'WhatsApp / 手机号码',
            phonePh: '12-345 6789',
            dateLabel: '首选预约日期',
            timeLabel: '首选时间',
            timeOptions: ['上午 (10:00 – 13:00)', '中午 (13:00 – 15:00)', '下午 (15:00 – 18:00)'],
            successTitle: '已收到预约申请',
            successBody: '诊所团队将确认时间并与您联系。您的信息已与 Aira 共享——继续与她对话时无需重复。',
            successAira: '继续与 Aira 对话',
            successWa: '前往 WhatsApp',
            time: '希望的预约时间',
            timePh: '例如：这个周末，下午',
            country: '您目前在',
            countryOptions: ['马来西亚', '新加坡', '印尼', '其他'],
            message: '简短留言',
            messagePh: '简单告诉我们您的顾虑',
            submit: '发送咨询',
            success: '谢谢您。诊所会尽快回复您。',
            error: '抱歉，发送失败。请直接 WhatsApp 我们。',
            consent: '提交此表单即表示您同意我们就您的咨询与您联系。您的资料仅用于此目的。',
        },
    },
    privacy: {
        metaTitle: '隐私政策 | Irma Ariandi 牙科诊所',
        metaDesc: 'Irma Ariandi 牙科诊所的隐私政策 —— 您的咨询资讯如何被收集、使用与保护。',
        title: '隐私政策',
        updated: '版本 1.0 —— 【日期待确认】',
        sections: [
            { h: '我们收集什么', p: '我们只通过咨询表单或 WhatsApp 收集您主动提供的资讯 —— 姓名、偏好的联系方式与咨询摘要。我们不会通过营销表单索取详细的病史。' },
            { h: '我们如何使用', p: '您的资讯仅用于回复咨询与安排预约，不会出售，也不会用于第三方营销。' },
            { h: 'Cookie 与分析', p: '本网站可能使用分析工具以汇总方式了解网站使用情况，不会用于识别您个人。' },
            { h: '存储与安全', p: '咨询内容被安全存储，只有诊所团队可以为了回复您而查看。' },
            { h: '您的权利', p: '如对您的资料有疑问，请电邮 klinikpergigianirmaariandi@gmail.com。' },
        ],
    },
    disclaimer: {
        metaTitle: '网站与医疗免责声明 | Irma Ariandi 牙科诊所',
        metaDesc: '本网站内容仅供教育参考，不能取代临床检查与诊断。',
        title: '网站与医疗免责声明',
        updated: '版本 1.0 —— 【日期待确认】',
        sections: [
            { h: '教育性质资讯', p: '本网站内容用于教育与一般资讯目的，不能取代临床检查、诊断或个人治疗方案。' },
            { h: '需要个人评估', p: '治疗的适合性、时长、复诊次数与结果因人而异。任何治疗决定都需要牙医的临床评估。' },
            { h: 'WhatsApp 不是诊断', p: 'WhatsApp 沟通帮助诊所为您指出合适的下一步，它不是诊断，也不能取代检查。' },
            { h: '不作保证', p: '我们不作治疗效果的保证承诺。我们承诺的是诚实的解释、透明的收费与人性的关怀。' },
        ],
    },
    notFound: {
        title: '找不到这个页面',
        text: '链接可能有误，或页面还在建设中。让我们带您回去。',
        cta: '回到首页',
    },
    footer: {
        about: '位于新山的牙科诊所。传统牙套、隐形牙套、FRC、氧化锆牙冠与牙桥、美学贴面与微笑改造。',
        quickLinks: '快捷链接',
        treatments: '治疗方案',
        international: '国际患者',
        kolum: 'Coffee With Dr. Irma',
        doctors: '医生',
        contact: '联系',
        privacy: '隐私政策',
        disclaimer: '网站与医疗免责声明',
        whatsapp: 'WhatsApp',
        email: '电邮',
        address: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
        addressSlot: '',
        rights: 'Klinik Pergigian Irma Ariandi. 版权所有。',
        disclaimerLine: '本网站资讯仅供教育参考，不能取代临床检查。',
    },
};
